export default {
  active: {
    id: 'merchant_options_payment_icon_active_label',
    defaultMessage: '{name} is active',
  },
  inactive: {
    id: 'merchant_options_payment_icon_inactive_label',
    defaultMessage: '{name} is inactive',
  },
  availableIn: {
    id: 'merchant_options_payment_available_in',
    defaultMessage: 'Available in:',
  },
  settings: {
    id: 'merchant_options_payment_settings',
    defaultMessage: 'Settings',
  },
  emailVerified: {
    id: 'merchant_options_payment_icon_email_verified_label',
    defaultMessage: 'Your email address has been verified',
  },
  emailNotVerified: {
    id: 'merchant_options_payment_icon_email_not_verified_label',
    defaultMessage: 'Your email address has not been verified',
  },
}
